export interface CompatibilityReport {
  supported: boolean;
  missingFeatures: string[];
}

/**
 * Checks for the browser APIs this app depends on for rendering. Chrome/Edge
 * (desktop) support all of these; Safari and Firefox have partial or no
 * OffscreenCanvas 2D support as of early 2026, which blocks in-browser export.
 */
export function checkBrowserCompatibility(): CompatibilityReport {
  const missing: string[] = [];

  if (typeof indexedDB === 'undefined') missing.push('IndexedDB (required to save your projects locally)');
  if (typeof OffscreenCanvas === 'undefined') missing.push('OffscreenCanvas (required for video export)');
  if (typeof AudioContext === 'undefined' && typeof (window as unknown as { webkitAudioContext?: unknown }).webkitAudioContext === 'undefined') {
    missing.push('Web Audio API (required for voiceover/music mixing)');
  }
  if (typeof createImageBitmap === 'undefined') missing.push('createImageBitmap (required for image rendering)');
  if (typeof Worker === 'undefined') missing.push('Web Workers (required for background rendering)');

  return { supported: missing.length === 0, missingFeatures: missing };
}
